export default "__VITE_ASSET__DOkWNmS2__"